/**
 * @desc 订阅回调
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  shopCode: string,
  body: defs.walmart.RedirectSubscriptionsOrderResponse,
  options?: any,
) {
  return updateResponse(
    http(URL + `/walmart/WalmartNotifications/redirectSubscriptions/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
